import { Form, Formik } from "formik";

import { Box, Button, Link, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import Checkbox from "@components/Forms/FormInputs/CheckBox";

interface IPrivacyPolicyAndTermsOfServiceModalProperties {
  isPrivacyPolicyAccepted: boolean;
  isTermsOfServiceAccepted: boolean;
  onSubmit: () => void;
}

export default function PrivacyPolicyAndTermsOfServiceModal({
  isPrivacyPolicyAccepted,
  isTermsOfServiceAccepted,
  onSubmit,
}: IPrivacyPolicyAndTermsOfServiceModalProperties) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        minWidth: "550px",
        width: "100%",
      }}
    >
      <Typography sx={{ mb: 0 }}>
        As part of our continued commitment to privacy and security, we have updated our Privacy Policy and Terms of
        Service. Please click on the following links to review and confirm that you agree to our terms before
        continuing:
      </Typography>
      <Formik
        initialValues={{
          isPrivacyPolicyAccepted,
          isTermsOfServiceAccepted,
        }}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, values }) => (
          <Form>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <Checkbox
                label={
                  <Typography>
                    I have read and agree to{" "}
                    <Link href="https://www.scaleip.com/privacy-policy" target="_blank">
                      ScaleIP&apos;s privacy policy
                    </Link>
                    .
                  </Typography>
                }
                name="isPrivacyPolicyAccepted"
              />
              <Checkbox
                label={
                  <Typography>
                    I have read and agree to{" "}
                    <Link href="https://www.scaleip.com/terms-of-service" target="_blank">
                      ScaleIP&apos;s terms of service
                    </Link>
                    .
                  </Typography>
                }
                name="isTermsOfServiceAccepted"
              />
              <Button
                disabled={!values.isPrivacyPolicyAccepted || !values.isTermsOfServiceAccepted}
                sx={{ mt: 3 }}
                type="submit"
                variant="contained"
              >
                {isSubmitting ? <CircularProgress size={20} /> : <>confirm</>}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
